import { Box, BoxProps, Text } from '@chakra-ui/react';

interface ErrorProps extends BoxProps {
  message: string;
}

export function Error({ message, ...props }: ErrorProps) {
  return (
    <Box py="64px" {...props}>
      <Text
        fontFamily="mono"
        fontSize="11px"
        letterSpacing="0.16em"
        textTransform="uppercase"
        color="accent.500"
        mb="12px"
      >
        algo deu errado
      </Text>
      <Text fontFamily="display" fontSize="32px" color="text.primary">
        {message}
      </Text>
    </Box>
  );
}
